export const ERROR_ACTION_NAMES = {
  UPDATE_STATE_ERROR: 'UPDATE_STATE_ERROR',
};

export const updateError = (data) => ({
  type: ERROR_ACTION_NAMES.UPDATE_STATE_ERROR,
  payload: data,
});
